(() => {
  function initialize(root = document) {
    const nav = root.querySelector('.ext-nav');
    if (!nav || nav.dataset.novReady) return;
    nav.dataset.novReady = 'true';
    const items = [...nav.querySelectorAll('[data-has-mega]')];
    const overlay = nav.parentElement.querySelector('.ext-overlay');
    const desktop = matchMedia('(min-width:990px)');
    const hover = matchMedia('(hover:hover) and (pointer:fine)');
    let active = null, openTimer, closeTimer;
    function clearTimers() { clearTimeout(openTimer); clearTimeout(closeTimer); }
    function close(returnFocus = false) {
      clearTimers();
      const old = active;
      items.forEach(item => {
        item.classList.remove('is-open');
        item.querySelector('.ext-nav__trigger').setAttribute('aria-expanded', 'false');
      });
      overlay?.classList.remove('is-visible');
      document.body.classList.remove('mega-menu-open');
      active = null;
      if (returnFocus && old) old.querySelector('.ext-nav__trigger').focus();
    }
    function open(item) {
      clearTimers();
      if (!desktop.matches) return;
      if (active !== item) close();
      active = item;
      item.classList.add('is-open');
      item.querySelector('.ext-nav__trigger').setAttribute('aria-expanded', 'true');
      overlay?.classList.add('is-visible');
      document.body.classList.add('mega-menu-open');
    }
    items.forEach(item => {
      const button = item.querySelector('.ext-nav__trigger');
      item.addEventListener('pointerenter', () => {
        if (!hover.matches || (active && active !== item && active.contains(document.activeElement))) return;
        clearTimers();
        openTimer = setTimeout(() => open(item), active ? 160 : 110);
      });
      item.addEventListener('pointerleave', () => {
        if (!hover.matches) return;
        clearTimers();
        closeTimer = setTimeout(() => { if (active === item && !item.contains(document.activeElement)) close(); }, 280);
      });
      button.addEventListener('click', () => active === item ? close() : open(item));
      button.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault(); open(item);
          setTimeout(() => { if (active === item) item.querySelector('.ext-mega a')?.focus(); }, 180);
        }
      });
      item.querySelector('.ext-mega')?.addEventListener('pointerenter', clearTimers);
    });
    nav.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); close(true); } });
    document.addEventListener('focusin', event => { if (active && !active.contains(event.target)) close(); });
    overlay?.addEventListener('click', () => close());
    desktop.addEventListener('change', () => close());
    window.addEventListener('pagehide', () => close(), {once:true});
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

